import { createZustandStore } from '../../../zustand';

import { DEFAULT_SCAN_TYPE } from '../../inbound';

import { ICancelTransferStore } from './types';

/**
 * This is to track the mutation key for scanning a pod or tray code
 * for inventory transfer.
 */
export const useCancelTransfer = createZustandStore<ICancelTransferStore>()(
  (set) => ({
    isPodScan: false,
    updateIsPodScan: (isPodScan) => set(() => ({ isPodScan })),
    currentScanStep: 'scan-tray-or-pod',
    transferTrayFilter: 'IN_PROGRESS',
    updateTransferTrayFilter: (transferTrayFilter) =>
      set(() => ({ transferTrayFilter })),
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    scanType: DEFAULT_SCAN_TYPE,
    updateScanType: (scanType) => set(() => ({ scanType })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    transferDetails: null,
    updateTransferDetails: (transferDetails) =>
      set(() => ({ transferDetails })),
    resetStore: () =>
      set({
        currentScanStep: 'scan-tray-or-pod',
        scanType: DEFAULT_SCAN_TYPE,
        isScannerReadingData: false,
        isPodScan: false,
        transferDetails: null,
        transferTrayFilter: 'IN_PROGRESS',
      }),
  })
);
